<template>
  <!-- 游记达人组件 -->
  <div class="travel">
    <diy-tab title="游记达人" type="tab" color="#ff5722" active>
      <diy-tab-item name="first" label>
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item title="奇怪4人组的珠海御温泉2天1夜" name="1">
            <a href="http://www.mafengwo.cn/i/11764162.html" target="_bank">
              <img
                src="http://b4-q.mafengwo.net/s10/M00/84/89/wKgBZ1xVkyiALnOfAAx9FNOkiC019.jpeg?imageView2%2F2%2Fw%2F680%2Fq%2F90%7CimageMogr2%2Fstrip%2Fquality%2F90"
              />
            </a>
            <div class="travels-item-content">两姐妹+一对情侣的奇妙旅程！</div>
          </el-collapse-item>
          <el-collapse-item title="最美的时光在路上，最美的风景在远方！" name="2">
            <a href="http://www.mafengwo.cn/i/10425226.html" target="_bank">
              <img
                src="http://n1-q.mafengwo.net/s12/M00/FD/B0/wKgED1uOJ3WAH3eUAAjxJaXMZLY47.jpeg?imageView2%2F2%2Fw%2F680%2Fq%2F90%7CimageMogr2%2Fstrip%2Fquality%2F90"
              />
            </a>
            <div class="travels-item-content">旅行的目的就在于拍！拍！拍！记录美好的瞬间！</div>
          </el-collapse-item>
          <el-collapse-item title=" 你好，我的陌生人宿友！" name="3">
            <a href="http://www.mafengwo.cn/i/11271986.html" target="_bank">
              <img
                src="http://p3-q.mafengwo.net/s12/M00/53/8F/wKgED1v9UeKAY9SVABFRZQ9r7o433.jpeg?imageView2%2F2%2Fw%2F680%2Fq%2F90%7CimageMogr2%2Fstrip%2Fquality%2F90"
              />
            </a>
            <div class="travels-item-content">快来看看这四位小姐姐的体验之旅！教你如何玩转御温泉~</div>
          </el-collapse-item>
        </el-collapse>
      </diy-tab-item>
    </diy-tab>
  </div>
</template>

<script>
import DiyTab from "@/components/DiyTab/index";
import DiyTabItem from "@/components/DiyTab/DiyTabItem";
export default {
  components: {
    DiyTab,
    DiyTabItem
  },
  data() {
    return {
      activeName: ["1"]
    };
  }
};
</script>
<style>
/* 手风琴 */
.travel .el-collapse-item__header {
  padding-left: 20px;
}
</style>
<style lang="scss" scoped>
.travel {
  width: 100%;
  .travels-item-content {
    line-height: 21px;
    padding: 40px;
    color: #747474;
    letter-spacing: 1px;
  }
}
</style>
